// extracted by mini-css-extract-plugin
module.exports = {"Block":"Block_Block__3zgQv","DeleteIcon":"Block_DeleteIcon__3KUzE","BlockBody":"Block_BlockBody__38d6Z"};